<template>
  <div class="accounts">
    <div class="accounts__main accounts__block">
      <header class="accounts__header">
        <BaseTitle
          v-if="title"
          v-bind="title"
          class="accounts__title"
        />
      </header>
      <div class="accounts__content">
        <div v-if="items.length" class="accounts__items pretty-scrollbar">
          <div
            v-for="(item, i) in items"
            :key="`accounts__item_${i}`"
            class="accounts__item"
          >
            <div class="accounts__code">{{ item.code }}</div>
            <div class="accounts__address">{{ item.address }}</div>
          </div>
        </div>
        <div
          v-else
          v-html="emptyText"
          class="accounts__empty"
        />
      </div>
    </div>
    <div class="accounts__side">
      <div class="accounts__block">
        <BaseText
          v-if="addDescription"
          v-bind="addDescription"
        />
        <div class="accounts__actions">
          <BaseButton
            :text="addButtonText"
            @click="$emit('add')"
          />
        </div>
      </div>
      <div class="accounts__block">
        <BaseText
          v-if="findDescription"
          v-bind="findDescription"
        />
        <div class="accounts__actions">
          <BaseButton
            :text="findButtonText"
            @click="$emit('find')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'MyAccounts',
  components: {
    BaseTitle,
    BaseText,
    BaseButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    title() {
      return {
        text: this.$t('titles.accountsList'),
        isNormal: true,
        size: 'm',
      };
    },
    addDescription() {
      return {
        text: this.$t('texts.bindAccount'),
        theme: 'bright',
      };
    },
    findDescription() {
      return {
        text: this.$t('texts.findAccount'),
        theme: 'bright',
      };
    },
    emptyText() {
      return this.$t('texts.emptyAccounts');
    },
    addButtonText() {
      return this.$t('actions.addAccount');
    },
    findButtonText() {
      return this.$t('actions.findAccount');
    },
  },
};
</script>

<style lang="stylus">
.accounts
  display flex
  width 100%
  height 100%

  $accounts_side_padding = 1.5em

  &__main
  &__side
    flex-grow 1
    flex-basis 0
    max-width 100%

  &__main
    display flex
    flex-direction column
    max-width 60%
    height 100%

  &__side
    max-width 40%
    padding-left 1em

  &__block
    background-color #fff
    box-shadow 0 0.6em 1em -0.5em alpha($c_primary, 20%)
    border-radius 0.2em
    padding $accounts_side_padding
    & + &
      margin-top 1em

  &__title
    margin-top -0.2em
    margin-bottom 1em

  &__content
    position relative
    flex 1
    min-height 0
    &:after
      content ''
      abs bottom left right
      height 2em
      background linear-gradient(180deg, alpha(#fff, 0), #fff)
      pointer-events none
      margin-bottom -1px
      z-index 1

  &__items
    height 100%
    padding-top 0.25em
    padding-bottom 2em
    &.pretty-scrollbar
      margin-right ($accounts_side_padding * -1)
      padding-right 'calc(%s - %s)' % ($accounts_side_padding ($scroll_width * 1px))

  &__actions
    margin-top 1.25em

  &__empty
    color $c_text_dim

  &__item
    padding-top 1.5em
    margin-top 1.5em
    border-top solid 1px alpha($c_text_dim, 15%)
    &:first-child
      margin-top 0
      border-top 0
      padding-top 0

  &__code
    font-size 1.1em
    color $c_primary

  &__address
    font-size 0.9em
    color $c_text_dim
    margin-top 0.5em
</style>
